import { useNavigate } from 'react-router';
import './style.scss';

const Problem = () => {
  const navigate = useNavigate();

  const handleRefreshAppClick = () => {
    navigate('/home', { replace: true });

    setTimeout(() => {
      location.reload();
    }, 100);
  };
  return (
    <div className='problem-container'>
      <h1 className='problem-container_title'>Something Went Wrong!</h1>
      <p className='problem-container_description'>
        {window.navigator.onLine
          ? 'Sorry, Something went wrong. Please try again.'
          : 'It seems that you are offline, please try again later.'}
      </p>
      {window.navigator.onLine && (
        <button
          className='problem-container_button'
          type='button'
          onClick={handleRefreshAppClick}
        >
          Retry
        </button>
      )}
    </div>
  );
};

export default Problem;
